import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  ModalReducerType,
  ModalOpenState,
  ModalCloseState,
  FORGOT_PASSWORD_MODAL,
  RECOVER_PASSWORD_MODAL,
  PICKUP_MODAL,
  SHIPPING_DETAIL_MODAL,
  CONTACT_MODAL,
  CONTACTS_LIST_MODAL,
  CONFIRM_MODAL, ADDRESSES_LIST_MODAL, ADDRESS_MODAL, CANCEL_SHIPMENT_MODAL,EDIT_PICKUP_MODAL, SHIPMENT_PROVE_MODAL
} from './Types';
import {FormType} from "../../Models/FormType";

const defaultInitialStateProperties = {
  open: false
};

const initialState: ModalReducerType = {
  openModalQuantity: 0,
  [FORGOT_PASSWORD_MODAL]: defaultInitialStateProperties,
  [RECOVER_PASSWORD_MODAL]: defaultInitialStateProperties,
  [PICKUP_MODAL]: defaultInitialStateProperties,
  [SHIPPING_DETAIL_MODAL]: defaultInitialStateProperties,
  [CONTACT_MODAL]: defaultInitialStateProperties,
  [CONTACTS_LIST_MODAL]: defaultInitialStateProperties,
  [CONFIRM_MODAL]: defaultInitialStateProperties,
  [ADDRESSES_LIST_MODAL]: defaultInitialStateProperties,
  [ADDRESS_MODAL]: defaultInitialStateProperties,
  [CANCEL_SHIPMENT_MODAL]: defaultInitialStateProperties,
  [EDIT_PICKUP_MODAL]: defaultInitialStateProperties,
  [SHIPMENT_PROVE_MODAL]: defaultInitialStateProperties,
};

const Modal = createSlice({
  name: "Modal",
  initialState,
  reducers: {
    openModal(state: ModalReducerType, {payload}: PayloadAction<ModalOpenState<any, any>>) {
      const modal = state[payload.modal];
      const data = {shouldCloseOnCancel: false, ...payload.data};
      const formType: FormType = data.formType;
      if (formType && formType === FormType.UPDATE) {
        data.shouldCloseOnCancel = true;
      }
      modal.open = true;
      modal.data = data;
      modal.cb = payload.cb;
      state.openModalQuantity++;
    },
    closeModal(state: ModalReducerType, {payload}: PayloadAction<ModalCloseState<any>>) {
      const modal = state[payload.modal];
      const formType = modal.data?.formType;
      if (formType && formType === FormType.UPDATE && !modal.data.shouldCloseOnCancel) {
        modal.data = {...modal.data, formType: FormType.SHOW};
      } else {
        modal.open = false;
        modal.data = null;
      }
    },
    updateModal(state: ModalReducerType, { payload: { modal, data, cb }}: PayloadAction<ModalOpenState<any, any>>) {
      if (cb) {
        state[modal].cb = cb;
      }
      state[modal].data = {...state[modal].data, ...data};
    },
    cleanModal(state: any, { payload: { modal } }: PayloadAction<any>) {
      state[modal] = defaultInitialStateProperties
    }
  }
});

export const ModalActions = Modal.actions;

export default Modal.reducer
